import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group flex flex-col sm:flex-row gap-4 bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-primary-300 transition-all duration-300 cursor-pointer p-4"
    >
      <div className="w-full sm:w-48 h-32 flex-shrink-0 overflow-hidden rounded-md">
        <img
          src={article.image}
          alt={article.title}
          title={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="flex-1 min-w-0 flex flex-col justify-between">
        <div>
          <div className="flex items-center gap-2 mb-1 flex-wrap">
            <span className="px-2 py-0.5 text-xs font-medium bg-primary-100 text-primary-700 rounded">
              {article.category}
            </span>
            <span className="text-xs text-foreground-400">{article.date}</span>
            <span className="text-xs text-foreground-400">{article.readTime}阅读</span>
          </div>
          <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
            {article.title}
          </h3>
          <p className="text-xs text-foreground-500 mt-1 line-clamp-2 leading-relaxed">
            {article.excerpt}
          </p>
        </div>
        <div className="flex items-center gap-2 mt-2 flex-wrap">
          {article.tags.map((tag) => (
            <span key={tag} className="px-1.5 py-0.5 text-xs bg-secondary-100 text-secondary-600 rounded">
              {tag}
            </span>
          ))}
          <span className="text-xs text-foreground-400 ml-auto">
            <i className="ri-eye-line mr-0.5"></i>
            {article.views.toLocaleString()}
          </span>
        </div>
      </div>
    </Link>
  );
}